<ng-container *ngIf="renderAsButton; else spanTemplate">
    <button
        pButton
        [class.hide]="hidden"
        class="editButton"
        icon="pi pi-info-circle"
        [text]="true"
        [pTooltip]="useOverlay ? null : tooltip"
        [tooltipEvent]="responsiveHelper.isSmallScreen ? 'focus' : 'hover'"
        (click)="useOverlay && toggleOverlay($event)"
    ></button>
</ng-container>

<ng-template #spanTemplate>
    <span
        [class.hide]="hidden"
        [pTooltip]="useOverlay ? null : tooltip"
        [tooltipEvent]="responsiveHelper.isSmallScreen ? 'focus' : 'hover'"
        (click)="useOverlay && toggleOverlay($event)"
        [class.clickable]="useOverlay"
    >
        <ng-content></ng-content>
        <i class="pi pi-info-circle"></i>
    </span>
</ng-template>

<p-overlayPanel #overlayPanel *ngIf="useOverlay">
    <ng-template pTemplate>
        <div class="info-overlay-content">
            {{ overlayContent }}
        </div>
    </ng-template>
</p-overlayPanel>
